<template>
  <el-container :class="['bizEntry-page', busiCode, busiCode + '-' + userType]" v-if="isShow">
    <flowTip ref="flowTip"></flowTip>
    <el-main id="bizEntry-main" :class="['bizEntry-main', 'customer-view', groupId]">
      <el-form :inline="true" label-position="right">
        <div v-for="(moduleArr, moduleKey) in moduleDatas" :class="['self-module-div', moduleKey]" :key="moduleKey">
          <module-item :disabled = 'disabledArray.length' :moduleItem.sync="module" :ref="module.MODULE_ID+module.MODULE_SEQ" :key="groupId+module.MODULE_ID+module.MODULE_SEQ" :index="index" v-for="(module,index) in moduleArr"  :busiLogic='busiLogic'>
          </module-item>
        </div>
      </el-form>
      <!-- <my-checkbox parentId="bizEntry-main" ref="myCheckbox"></my-checkbox> -->
    </el-main>
    <try-again :message-type="messageType" v-on:reloadPage="refreshPage" v-if="messageTypeShow"></try-again>
    <el-footer class="bizEntry-footer fixed_btn operator-footer-btn-group" v-if="isShowFooter">
        <el-col :span="4" v-if="isShowBack">
          <el-button class="button light-button back" round @click="goBackList">返回列表</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowRestore">
          <el-button class="button restore" round @click="restore">取消修改</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowPrev">
          <el-button id="bizEntryPrevBtn" class="button light-button prev" :disabled="disablePrev" round @click="prev">
            {{ prevBtnText }}</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowNext">
          <el-button id="bizEntryNextBtn" class="button light-button-save next" :disabled="disableNext" round @click="next">
          {{ nextBtnText }}</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowTmpSave && (apptStatus==1 || !apptStatus)">
          <el-button id="bizEntryNextBtn" class="button light-button-save next" :disabled="disableNext" round @click="next(false)">暂存</el-button>
        </el-col>
    </el-footer>
     <!-- <ocr-card v-if="showOcrCard"
        @getOcrInfo="getOcrInfo"
        :cardFieldData = "cardFieldData"
        @ocrBackAction ="ocrBackAction" :ocrBackType="'1'"  :ocrCardType = "ocrCardType">
      </ocr-card> -->
    <!-- <ocr-only ref="ocrOnly"></ocr-only> -->
    <!-- <police-validate-info ref="policeValidateInfoBox" :policeValidateInfo = "policeValidateInfo"></police-validate-info> -->
    <!-- <zd-validate-info ref="zdValidateInfoBox" :zdValidateInfo = "zdValidateInfo"></zd-validate-info> -->
    <!-- <csdc-info
        v-if="showCsdcInfoPage"
        :showCsdcInfoPage="showCsdcInfoPage"
        :csdcInfo="csdcInfo"
        :csdcIdType="csdcIdType"
        @nextCsdcInfo="nextCsdcInfo"
        @cancelCsdcInfo="cancelCsdcInfo" >
    </csdc-info> -->
    <!-- <radio-box v-if="radioBoxProps"
        :boxValue.sync="radioBoxProps.boxValue"
        :boxDictArr="radioBoxProps.boxDictArr"
        :boxFieldId="radioBoxProps.boxFieldId"
        :boxLabel="radioBoxProps.boxLabel"
        :boxTitle="radioBoxProps.boxTitle"
      :confirmFn="radioBoxProps.confirmFn"
        :cancelFn="radioBoxProps.cancelFn">
    </radio-box> -->

    <!-- <kui-dialog ref = "showHelpPageDialog" :options = "{title:'帮助指引',center:true,width: '80%',height:900,top:'0',destroyOnClose:true,buttons:[{text:'关闭'}]}">
      <vueshowpdf v-if = "!!pageHelpUrl" :pdfurl="pageHelpUrl" ></vueshowpdf>
    </kui-dialog>
    <kui-dialog class="fund-dialog" ref = "showFundDialog" :options = "{title:'提示',center:true,width: '40%',height:415,top:'0',buttons:[{text:'确定'}]}">
        <span class="fund-qr-code"><img height="100%" src="../../icons/QR_code.png"></span>
        <span class="fund-qr-text">请通过中国基金业协会网站“私募基金管理人公示平台”（http://gs.amac.org.cn）或“私募汇”手机APP 客户端核实客户登记信息及编码信息。</span>
    </kui-dialog> -->
  </el-container>
</template>

<script>
import moduleItem from "../../components/preEntry/moduleItem";
import tryAgain from "../../components/common/tryAgain.vue";
import flowTip from "@/components/common/flowTip";
// import ocrCard from '../ocrCard/ocrCard';
// import policeValidateInfo from '../../components/common/policeValidateInfo'
// import zdValidateInfo from '../../components/common/zdValidateInfo'
// import csdcInfo from "../../components/common/csdcInfo.vue";
// import radioBox from "../../components/common/radioBox.vue";
// import vueshowpdf from "../../components/common/vue-pdf";
// import ocrOnly from '../../components/common/ocrOnly.vue'
// import myCheckbox from "../../components/common/myCheckbox.vue";
/**
 * @component bizEntry
 * @desc 通用业务配置页面渲染模块
 * @route /bizFlow/bizEntry
 * @lifecycle activated 初始化页面渲染
 * @fires component:moduleItem 模块组件
 * @fires component:tryAgain 重试组件
 * @fires component:messageBox 弹出框组件
 * @fires component:loading 加载框组件
 * @fires component:flowTip 提示条组件
 */
export default {
  name: "bizEntry",
  componentName: "bizEntry",
  components: {
    moduleItem,
    // tryAgain,
    flowTip,
    // ocrCard,
    // policeValidateInfo,
    // zdValidateInfo,
    // csdcInfo,
    // radioBox,
    // vueshowpdf,
    // ocrOnly,
    // myCheckbox
  },
  data () {
    return {
      /**
       * @member {Object} moduleDatas 页面渲染模块数据
       */
      moduleDatas: {},
      /**
       * @member {String} messageType 页面加载异常提示类型
       */
      messageType: "loadFail",
      /**
       * @member {String} messageType 页面加载异常显示页面的标志位
       */
      messageTypeShow: false,
      changedField: [],
      isShowRestore: false,
      isShowBack:false,
      disablePrev: false,
      disableNext: false,
      isRunFieldRules: false,
      showOcrCard:false,
      showOcrModuleId:"",
      isDisabled:false,
      cardFieldData:{},
      ocrCardType: "",
      policeValidateInfo: {
        url: "",
        result: []
      },
      zdValidateInfo:{
        url: "",
        result: []
      },
      showCsdcInfoPage: false, // 中登信息查询数据的页面是否展示
      csdcInfo: {}, // 中登信息 中登辅助录入
      csdcIdType: "",
      radioBoxProps: "",
      isShowFooter:true,
      pageHelpUrl:""
    };
  },
  props: [
    /**
     * @vprop {Object} groupDatas 页面渲染数据
     */
    "groupDatas",
    /**
     * @vprop {Object} groupDatasTpl 页面渲染数据模板
     */
    "groupDatasTpl",
    /**
     * @vprop {Object} oldGroupDatas 页面渲染初始历史数据
     */
    "oldGroupDatas",
    /**
     * @vprop {Object} historyData 业务历史流水数据
     */
    "historyData",
    /**
     * @vprop {Object} oppBusiData 业务临时数据
     */
    "oppBusiData",
    /**
     * @vprop {Number} pageNum 业务页码
     */
    "pageNum",
    /**
     * @vprop {Boolean} isShowPrev 控制是否显示上一步
     */
    "isShowPrev",
    /**
     * @vprop {Boolean} isShowNext 控制是否显示下一步
     */
    "isShowNext",
    /**
     * @vprop {Boolean} isShowContinue 控制是否显示继续按钮
     */
    "isShowContinue",
    /**
     * @vprop {Boolean} isShowPageIndex 控制是否显示右下标页面
     */
    "isShowPageIndex",
    /**
     * @vprop {Function} save bizFlow保存数据流水方法
     */
    "save",
    "busiCode",
    /**
     * @vprop {Function} tackClick bizFlow点击返回列表方法
     */
    "clickLeftStep",
    "openAcctType",
    "disabledArray",
    "noUpdateApptStatus"
  ],
  activated () {
    this.initPage();
  },
  computed: {
    isShow:  function () {
      //点击下一步bizentry ->bizpage 跳转bizpage时，会先重新渲染一次bizentry，即便路由已经切换的情况，
      //如果bizentry组件里有加载框，如normalocr 就会出现下一步跳转自定义页面时，还在加载ocr组件的loading
      return this.$route.name == "bizEntry";
    },
    apptStatus: function (){
      return this.$store.state.apptStatus;
    },
    /**
     * @computed {String} groupId 当前业务路由的分组groupId
     */
    groupId: function () {
      return this.$router.getCurrentRoute().group;
    },
    /**
     * @computed {String} moduleId 当前业务路由的模块moduleId
     */
    moduleId: function () {
      let moduleId = this.$router.getCurrentRoute().modules;
      return moduleId ? (Object.prototype.toString.call(moduleId) == "[object Array]" ? moduleId : [moduleId]) : [];
    },
    /**
     * @computed {String} busiCode 当前模块的form
     */
    fromId: function () {
      return this.$router.getCurrentRoute().from || "";
    },
    /**
     * @computed {String} userType 当前用户类型
     */
    userType () {
      return this.$store.state.usertype;
    },
    /**
     * @computed {Object} qsVersionName 券商机构名称
     */
    qsVersionName (){
      return this.$bizcfg.getBizConfigName(this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion]);
    },
    /**
     * @computed {Object} busiLogic 业务逻辑数据体
     */
    busiLogic () {
      return require(`../../business/businessFile//${this.busiCode}/${this.busiCode}`).default;
    },
    /**
     * @computed {Boolean} isCommit 控制是否提交数据
     */
    isCommit: function () {
      return this.$router.getCurrentRoute().isCommit;
    },
    /**
     * @computed {Boolean} isShowTmpSave 控制是否显示暂存按钮
     */
    isShowTmpSave: function () {
      return !this.$router.getCurrentRoute().isHideTmpSave;
    },
    /**
     * @computed {Boolean} beginFieldValidate 控制是否在业务页面初始化后就触发校验字段正确
     */
    beginFieldValidate: function () {
      return this.$router.getCurrentRoute().beginFieldValidate;
    },
    /**
     * @computed {Boolean} checkFieldChange 控制是否检查字段变更情况
     */
    checkFieldChange: function () {
      return this.$router.getCurrentRoute().checkFieldChange;
    },
    /**
     * @computed {Boolean} useModuleId 控制是否使用模块渲染页面，否则使用分组渲染页面
     */
    useModuleId: function () {
      var flag = this.groupDatas && this.moduleId.length > 0 && (_.difference(this.moduleId, Object.keys(this.groupDatas[this.groupId])).length == 0);
      return flag;
    },
    /**
     * @computed {Number} modifyType 控制是否显示还原,如果模型状态为待修改则不显示
     */
    modifyType: function () {
      return "modifyType" in this.$route.query ? this.$route.query.modifyType : -1;
    },
    componentButtonClick: function () {
      return this.$store.state.componentbuttonclick;
    },
    componentButtonTwoClick: function () {
      return this.$store.state.componentbuttontwoclick;
    },
    moduleBenifiCustomizeButtonClick: function () {
      return this.$store.state.moduleBenifiCustomizeButtonClick;
    },
    moduleButtonClick: function () {
      return this.$store.state.modulebuttonclick;
    },
    moduleCustomizeButtonClick: function () {
      return this.$store.state.moduleCustomizeButtonClick;
    },
    moduleZDCustomizeButtonClick: function () {
      return this.$store.state.moduleZDCustomizeButtonClick;
    },
    moduleDownloadButtonClick: function () {
      return this.$store.state.moduleDownloadButtonClick;
    },
    moduleImportButtonClick: function () {
      return this.$store.state.moduleImportButtonClick;
    },
    fieldChange: function () {
      return this.$store.state.fieldchange;
    },
    fieldValueChange: function () {
      return this.$store.state.fieldValueChange;
    },

    /**
     * 关闭flowtip回调函数
     */
    closeFlowtipClick (){
      return this.$store.state.closeFlowtipClick;
    },
    /**
     * @computed {String} prevBtnText 上一步按钮文本
     */
    prevBtnText () {
      return this.$router.getCurrentRoute().prevBtnText;
    },
    /**
     * @computed {String} nextBtnText 下一步按钮文本
     */
    nextBtnText () {
      return this.$router.getCurrentRoute().nextBtnText;
    },
    pageIndexText (){
      var bizAllRouterTable = this.$store.state.bizRouteTable;
      var curGroupizRouterTableArr = _.filter(bizAllRouterTable || [], obj => {
        return obj.group == this.groupId && !!obj.show && (!this.fromId || (this.fromId == obj.from));
      });
      var curMoudleRouterIndex = _.findIndex(curGroupizRouterTableArr, obj => {
        return  _.isEqual(obj.modules,this.moduleId);
      });
      return (curMoudleRouterIndex + 1) + "/" + curGroupizRouterTableArr.length;
    },
    compBusiModule () {
      var curouter = this.$router.getCurrentRoute();
      return curouter.compBusiModule || "";
    }
  },
  methods: {
    /**
     * @method getTypeLength
     * @desc 把流程提示组件的方法直接挂载到bizEntry实例上
     * @param  {String} type 提示类型 success/warning/info/error
     * @return {Number} 如果有就是对应项目的index 否则返回0
     */
    getTypeLength (type){
      return this.$refs.flowTip.getTypeLength(type);
    },
    /**
     * @method pushFlowTip
     * @desc 添加提示信息
     * @param  {Object} tip 提示内容对象
     */
    pushFlowTip (tip){
      this.$refs.flowTip.pushFlowTip(tip);
    },
    /**
     * @method removeFlowTip
     * @desc 删除提示信息
     * @param  {Object} tip 提示内容对象
     */
    removeFlowTip (key){
      this.$refs.flowTip&&this.$refs.flowTip.removeFlowTip(key);
    },
    /**
     * @method restore
     * @desc 页面还原到历史流水状态
     */
    restore () {
      let that = this;
      confirm({
        content: "请确认您是否还原当前页面数据？",
        okText: "确认",
        cancelText: "取消",
        handler: (flag) => {
          if (flag) {
            that.showLoading("数据还原中...");
            for(let gk in that.groupDatas) {
              for(let mk in that.groupDatas[gk]) {
                if(that.moduleId.indexOf(mk) != -1) { // 还原当前module
                  let moduleControl = that.groupDatas[gk][mk][0]["MODULE_CONTROL"];
                  that.groupDatas[gk][mk] = _.cloneDeep(that.oldGroupDatas[gk][mk]);
                  for(let i = 0; i < that.groupDatas[gk][mk].length; i++) {
                    that.groupDatas[gk][mk][i]["MODULE_CONTROL"] = moduleControl; // 需更新为当前组的显示控制（有些默认不显示，后逻辑触发要显示）
                  }
                }
              }
            }

            that.moduleDatas = {};
            that.changedField = [];
            setTimeout(() => {
              that.initPage();
              //如果自定义，跨节点控制页面逻辑
              if("addModuleControlNode" in that.busiLogic) {
                that.busiLogic["addModuleControlNode"](that);
              }
            }, 500); // 设500ms以显示加载框
          }
        }
      });
    },
    /**
     * @method initPage
     * @desc 初始化页面
     */
    async initPage () {
      // 页面切换初始化，清除所有提示项，应该所有业务都是这个逻辑
      // this.$refs.flowTip.removeAllFlowTip();
      // 动态引入各个业务自定义样式
      require(`../../business/businessFile//${this.busiCode}/${this.busiCode}.less`);

      if(this.useModuleId) {
        let tmpModuleDatas = {};
        for(let i = 0; i < this.moduleId.length; i++)
          tmpModuleDatas[this.moduleId[i]] = this.groupDatas[this.groupId][this.moduleId[i]];

        this.moduleDatas = tmpModuleDatas;
      } else
        this.moduleDatas = this.groupDatas[this.groupId];

      await this.initBizRules();
      this.checkModuleRules(this.groupId, this.moduleId);
      // this.checkChangedValues(this.groupId, this.moduleId);
      setTimeout(() => {
        this.checkChangedValues(this.groupId, this.moduleId);
        this.checkRequiredNull();
        // this.$closest("bizFlow").isShowJumpButton();
      }, 0);
      // this.$emit("updateBizAccess", this.compBusiModule);
      this.showLoading();
    },
    /**
     * @method checkModuleRules
     * @desc 页面更新完后，根据设置 MODULE_ASH = true 完成对模块的置灰操作
     * @param  {String} groupId 分组id
     * @param  {String} moduleId 模块id
     */
    checkModuleRules (groupId, moduleId) {
      let that = this;
      for(let gk in that.groupDatas) {
        if(typeof(groupId) == "undefined" || groupId == null || gk == groupId) {
          for(let mk in that.groupDatas[gk]) {
            if(typeof(moduleId) == "undefined" || moduleId == null || mk == moduleId
                || (Object.prototype.toString.call(moduleId) == "[object Array]" && moduleId.indexOf(mk) > -1)) {
              let moduleData = this.groupDatas[gk][mk];
              if (moduleData[0].MODULE_ASH == true){
                this.isDisabled = true;
                _.each(moduleData,(v,c)=>{
                  _.each(v.FIELDS,(item)=>{
                    item.FIELD_CONTROL == "1"? "":item.FIELD_CONTROL = "2";
                  });
                  moduleData[c].MODULE_DISABLED = "1";
                });
              } else {
                _.each(moduleData,(v,c)=>{
                  moduleData[c].MODULE_DISABLED = "0";
                });
              }
            }
          }
        }
      }
    },
    /**
     * @method initBizRules
     * @desc 页面更新完后，初始化执行页面规则以及字段规则 <br/>
     *  1.执行页面处理函数 <br/>
     *  2.执行各个字段关联逻辑，初始化触发字段设置默认值，更新字典项和初始值状态等 <br/>
     *  3.执行各个字段的校验逻辑 <br/>
     */
    async initBizRules () {
      // 1.执行页面处理函数
      if("pageActivated" in this.busiLogic) {
        this.$store.commit(this.$types.UPDATE_CAN_CLEAN_DATA, false);
        await this.busiLogic.pageActivated(this, this.groupId);
      }

      // 2.执行各个字段关联逻辑，初始化触发字段设置默认值，更新字典项和初始值状态等
      this.runFieldRules();

      setTimeout(() => {
        this.$store.commit(this.$types.UPDATE_CAN_CLEAN_DATA, true);

      }, 2000);
      // 3.执行各个字段的校验逻辑
      if(this.beginFieldValidate) {
        this.$nextTick(() => {
          this.runFieldValidate();
        });
      }
    },
    /**
     * @method runFieldRules
     * @desc 执行字段关联逻辑
     */
    runFieldRules () {
      let cloneModuleDatas = _.cloneDeep(this.moduleDatas);
      let recallBizRules = [];
      this.isRunFieldRules = true;
      for(let mk in this.moduleDatas) {
        let md = this.moduleDatas[mk];
        for(let i = 0; i < md.length; i++) {
          let mdd = md[i];
          for(let fk in mdd["FIELDS"]) {
            let field = mdd["FIELDS"][fk];
            let changed = false;
            if(field.FIELD_FUNCTION) { // 触发相应的自定义规则
              let cols = field.FIELD_FUNCTION.split("|");
              for(let i = 0; i < cols.length; i++) {
                let cType = _.trim(cols[i]);
                // 带有二次请求历史数据的和需要重播的规则暂时不在初始化时触发，例如：GET_CUST_INFO，CHECK_BIRTHDAY
                if(cType in this.busiLogic && ["CHECK_OCR_ITEM", "GET_ZZ_DATA","GET_PRO_CACHES", "CHECK_YMT_TRDACCT_CODE", "CHECK_BIRTHDAY","CHECK_GEM_TRDACCT","CHECK_PASSWORD","CHECK_TRADE_MARKET","CHECK_BROKER_CODE"].indexOf(cType) == -1) {
                  this.busiLogic[cType](this, field, mdd["FIELDS"], mdd, i, "1");

                  changed = true;
                }
                // 带有年龄（会根据时间变化而触发）计算相关的规则需要保存起来进行二次触发，以免触发的数据被还原
                //实际控制人信息 也需要避免被还原，因为有可能在基础信息模块的关联逻辑里会把实际控制人信息清空
                if(cType in this.busiLogic && ["CHECK_BIRTHDAY","CHECK_TRADE_LVL"].indexOf(cType) != -1) {
                  recallBizRules.push({field:field, fields:mdd["FIELDS"]});
                }
              }
            }
            if(changed) {
              // 备份还原之前的值，以防有规则触发时被清空或更改
              // 备份还原之前的值和promptValue  如果不还原，可能会出现promptValue与DEFAULT_VALUE不一致，导致下一步会弹窗再次输入
              for(let fkk in mdd["FIELDS"]) {
                if(cloneModuleDatas[mk][i]["FIELDS"][fkk]["DEFAULT_VALUE"]) // 只还原不为空的旧值，以防账户存量数据中有空值被错误的还原了
                  mdd["FIELDS"][fkk]["DEFAULT_VALUE"] = cloneModuleDatas[mk][i]["FIELDS"][fkk]["DEFAULT_VALUE"];
                  //修改了检验类型VALID_TYPE 则有可能添加了二次校验的规则
                  //判断如果有二次校验 则直接赋值防止 需要二次校验
                mdd["FIELDS"][fkk]["promptValue"] = mdd["FIELDS"][fkk]["VALID_TYPE"].indexOf("prompt") > -1 ? mdd["FIELDS"][fkk]["DEFAULT_VALUE"] : "";
              }
            }
          }
        }
      }

      // 避免依赖时间变化触发的字段（例如：计算年龄）还原造成的错误，需要再次触发以在当前时间状态下更新值
      for(let j = 0; j < recallBizRules.length; j++) {
        let field = recallBizRules[j].field;
        let fields = recallBizRules[j].fields;
        let cols = field.FIELD_FUNCTION.split("|");
        for(let k = 0; k < cols.length; k++) {
          let cType = cols[k];
          if(cType in this.busiLogic) {
            this.busiLogic[cType](this, field, fields);
          }
        }
      }
      this.isRunFieldRules = false;
    },
    /**
     * @method runFieldValidate
     * @desc 执行字段校验逻辑
     */
    runFieldValidate () {
      let isPass = true;
      // 解决模块内有二次输入框 当输入完成数据直接点击下一步 提示报错信息 且 弹出二次检验框的问题
      for(let moduleName in this.moduleDatas) {
        // 模块列表
        let moduleList = this.moduleDatas[moduleName];
        for (let i = 0; i < moduleList.length; i++){
          // 当前模块
          let thisModule = moduleList[i];
          // 模块展示时再执行这一段验证
          if (thisModule.MODULE_CONTROL == "1") {
            // 模块下的字段
            let fields = thisModule.FIELDS;
            for(let fieldName in fields){
              let field = fields[fieldName];
              // 如果字段校验包含二次输入
              // promptValue一般是存在的  如果是第一次验证 会在第一次验证添加上，如果回填历史数据 为了使这个不弹框 在回填历史数据时应该加入promptValue
              if (field.VALID_TYPE.indexOf("prompt") > -1 && field.DEFAULT_VALUE != "" && field.DEFAULT_VALUE != field.promptValue && field.FIELD_CONTROL == "0") {
                this.showLoading();
                isPass = false;
              }
            }
          }

        }
      }

      for(let mk in this.moduleDatas) {
        let md = this.moduleDatas[mk];
        for(let i = 0; i < md.length; i++) {
          let mdd = md[i];
          //隐藏的模块不执行校验
          if(mdd.MODULE_CONTROL == "0"){
            continue;
          }
          for(let fk in mdd["FIELDS"]) {
            let tempField = mdd["FIELDS"][fk];
            //隐藏的，作废的字段不执行校验,自定义跳过校验的字段不执行,比如下一步会在validate里自动调用接口校验的资金号
            if(tempField.FIELD_CONTROL == "1" || tempField.FIELD_CONTROL ==="3" || tempField.skipCheck === "1"){
              continue;
            }
            //如果见证流水状态是审核中或者是预审中或者是已完成就禁止编辑所有字段
            if(this.apptStatus>= 13 || this.apptStatus == 2 || this.apptStatus == 11) {
              tempField.FIELD_CONTROL = "2";
            }
            try {
              this.$refs[mdd.MODULE_ID+mdd.MODULE_SEQ][0].$refs[tempField.FIELD_ID][0].$refs[tempField.FIELD_ID].validate("blur");
              this.$refs[mdd.MODULE_ID+mdd.MODULE_SEQ][0].$refs[tempField.FIELD_ID][0].$refs[tempField.FIELD_ID].validate("custom");
            } catch (e) {
              console.error(e);
              throw new Error("校验字段失败，字段配置错误！");
            }
          }
        }
      }
      if (!isPass) {
        return false;
      }
      return true;
    },
    prev () {
      let that = this;
      that.showLoading("正在核对您的业务数据...");
      return Promise.all([
        that.busiLogic.preValidate && _.isFunction(that.busiLogic.preValidate) ? that.busiLogic.preValidate(that) : true
      ]).then(function (res) {
        if(res[0] === false) {
          return;
        }else{
          that.$emit("on-prev-click");
        }
      }).finally(()=> {
        that.showLoading();
      });
    },
    //新增暂存功能，needValid为false,不校验字段，只保存数据，不跳转，且不能更新node_code
    next: _.debounce (function (needValid=true, showTip=true){
      let that = this;
      return new Promise(resolve=>{
        // 只允许跳转路由,不允许校验跟保存数据的预受理状态
        if (that.noUpdateApptStatus.includes(this.apptStatus)) {
          that.$emit("on-next-click");
          return false;
        }
        if (needValid && that.runFieldValidate() == false) {
          return false;
        }

        //在点击下一步，优先校验界面元素的有效性 @yexiaoqingp
        that.$nextTick(()=> {

          let data = that.parseGroupData(),
            errorFields = data[0];
          if(needValid && errorFields.length > 0) {
          // 如果有字段校验不通过，自动滚动到该字段
            if (document.querySelector(".el-form-item__error")) {
              this.$nextTick(()=>{
                let errorDom = document.querySelector(".el-form-item__error");
                // 判断获取DOM是否隐藏，如果DOM被隐藏，则找到第一个显示的DOM；
                if(errorDom.offsetParent === null) {
                  let errorDocument = document.querySelectorAll(".el-form-item__error"),tempErrorDom = [];
                  errorDocument.forEach((dom) => {
                    dom.offsetParent !== null && tempErrorDom.push(dom);
                  });
                  tempErrorDom.length && (errorDom = tempErrorDom[0]);
                }
                if (errorDom) {
                  errorDom.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "start"
                  });
                }
              });
            }
            if(window.isOnlyMaskTool&&window.MaskTool&&["V9998"].includes(that.busiCode)){
              window.MaskTool.coverGuide(document.getElementsByName(errorFields[0][3]+"-"+errorFields[0][4]+"-"+errorFields[0][2])[0],3000,"1");
            }else{
              // alert(_.isString(errorFields[0]) ? errorFields[0] : "'" + errorFields[0][1] + "'等字段输入错误或必填\n请更改后重试");
              vm.alert(_.isString(errorFields[0]) ? errorFields[0] : "'" + errorFields[0][1] + "'等字段输入错误或必填\n请更改后重试");
            }
            return false;
          }
          return Promise.all([
            needValid&&that.busiLogic.validate && _.isFunction(that.busiLogic.validate) ? that.busiLogic.validate(that) : true
          ]).then(function (res) {
            if(res[0] === false && needValid) {
              return false;
            }


            let params = data[1];
            let baseData = {};
            if(!needValid){
              //暂存 复用原来的node_code
              baseData.NODE_CODE = -1;
            }
            if(!that.isCommit) { // 不提交需缓存当前业务数据
              //更新historydata的值
              that.historyData = Object.assign(that.historyData, params);
              that.$emit("on-next-click");
              return true;
            } else {
              /**
                 * lbj 不再从 parseGroupData 中取数据保存
                 */
              params = _.cloneDeep(that.historyData);
              that.showLoading("正在核对您提交的业务数据...");
              return that.save(that, params, baseData).then(function (response) {
                if(!needValid && showTip){
                  vm.alert("暂存成功");
                }
                setTimeout(() => {
                  //等所有loading都关闭再跳转，防止过早触发pageactivated函数的loading，被finally关闭
                  needValid&&that.$emit("on-next-click");
                }, 200);
              }).catch(function (err) {
                if(err !== "preventNextStep") {   //阻止跳转下一页
                  alert(err.toString() + "，保存失败");
                }
              }).finally(function (){
                that.showLoading();
              });
            }
          }).finally(function (){
            that.showLoading();
            resolve(true);
          });
        });
      });
    }, 1000, {
      "leading": true,
      "trailing": false
    }),
    goBackList (){
      let that = this;
      return Promise.all([
        that.busiLogic.goBackListValidate && _.isFunction(that.busiLogic.goBackListValidate) ? that.busiLogic.goBackListValidate(that) : true
      ]).then(function (res) {

      });
    },
    /**
     * @method parseGroupData
     * @desc 解析业务数据，生成页面渲染数据
     */
    parseGroupData () {
      // let params = _.cloneDeep(this.historyData)
      // if(!params)
      let params = {};

      let errorFields = [];
      let tempModuleDatas = {};
      for(let key in this.moduleDatas) {
        let moduleArr = this.moduleDatas[key];
        tempModuleDatas[key] = [];
        for(let i = 0; i < moduleArr.length; i++){
          if(moduleArr[i].MODULE_CONTROL == "0"){ // 模块隐藏，忽略
            continue;
          } else if(moduleArr[i].MODULE_CONTROL == "1") {
            let fields = moduleArr[i]["FIELDS"];
            tempModuleDatas[key][i] = {};
            for(let j in fields) {
              let field = fields[j];
              // ignoreSaveValid: 存在有些字段，状态改为校验未通过仅是为了展示提示，点击下一步保存时，此参数为真，则可以忽略校验、提示弹框
              if((!field["correct"] && !field["ignoreSaveValid"] || (_.trim(field["DEFAULT_VALUE"]) === "" && _.indexOf(["1", "true"],field["FIELD_REQUIRED"]) > -1 ))
                && _.indexOf(["0", "2"],field["FIELD_CONTROL"]) > -1 && !field.hasRsaPwd) {
                field["showerr"] = true;
                field["correct"] = false;
                //拍照组件跟ocr组件 提示语个性化展示
                if(["normalPhoto","normalOcr"].indexOf(field.FIELD_TYPE) == -1 && !field.warnText){
                  errorFields.push([moduleArr[i].MODULE_TITLE, field.FIELD_TITLE, field.FIELD_ID, moduleArr[i].MODULE_ID, moduleArr[i].MODULE_SEQ]);
                }else{
                  errorFields.push(field.warnText || "请先采集"+moduleArr[i].MODULE_TITLE);
                }
              }

              let fieldControl = parseInt(field.FIELD_CONTROL);
              if(fieldControl == 1 || fieldControl == 3) // 如果为 1 3 都是隐藏的字段，不采集，跳过
                continue;

              let oldField = null;
              for(let gk in this.oldGroupDatas) {
                if(key in this.oldGroupDatas[gk] && this.oldGroupDatas[gk][key].length > i) {
                  oldField = this.oldGroupDatas[gk][key][i]["FIELDS"][j];
                  break;
                }
              }

              if(oldField && oldField.DEFAULT_VALUE === "" && field.DEFAULT_VALUE === "") // 过滤空值，但旧值不为空且变更为空，需保留
                continue;

              // 一个字段有隐藏的附加字段，添加进主字段
              for(let k in field["FIELD_ADDITION"]) {
                tempModuleDatas[key][i][k] = field["FIELD_ADDITION"][k];
              }

              // params[field["FIELD_ID"]] = field["DEFAULT_VALUE"];
              tempModuleDatas[key][i][field["FIELD_ID"]] = field["DEFAULT_VALUE"];
            }

            if(JSON.stringify(tempModuleDatas[key][i]) === "{}") // 字段都过滤了，为空对象，删除这个对象
              tempModuleDatas[key].splice(i, 1);
            else if("MODULE_NUM_FIELD" in moduleArr[i]) // 多组数据，取出NUM字段值并赋值MODULE_NUM_FIELD，传给一柜通
              tempModuleDatas[key][i][moduleArr[i]["MODULE_NUM_FIELD"]] = moduleArr[i]["MODULE_NUM"];
          }
        }

        // 检测添加的是否有重复相同的module,allowRepeat如果为1就不检测
        if(_.get(moduleArr,"[0].allowRepeat","") !== "1" && tempModuleDatas[key].length > 1) {
          let hasEqual = false;
          for(let i = 0; i < (tempModuleDatas[key].length - 1); i++) {
            let fm = tempModuleDatas[key][i];
            let sm = tempModuleDatas[key][i + 1];
            if(fm && sm && _.difference(_.keys(fm), _.keys(sm)).length == 0 && _.difference(_.values(fm), _.values(sm)).length == 0) {
              hasEqual = true;
              break;
            }
          }
          if(hasEqual)
            errorFields.push("不能添加重复的【" + moduleArr[0].MODULE_TITLE + "】");
        }
      }

      if(this.groupId in params) {
        for(let tk in tempModuleDatas) {
          if(tk in params[this.groupId]) {
            delete params[this.groupId][tk];
          }
        }

        tempModuleDatas = Object.assign(params[this.groupId], tempModuleDatas);
      }
      params[this.groupId] = tempModuleDatas;
      return [errorFields, params];
    },
    /**
     * @method getBizData
     * @desc 获取业务流水数据
     * @param {Object} param 请求传参，一般传流水号或三要素获取
     * @return {Promise}
     */
    getBizData: function (param) {
      return this.$syscfg.K_Request("F0000036", param);
    },
    /**
     * @method checkChangedValues
     * @desc 检查页面是否有修改
     * @param  {String} groupId 分组id
     * @param  {String} moduleId 模块id
     * @param  {Number} index 模块多组索引
     * @param  {String} fieldId 字段id
     */
    checkChangedValues: function (groupId, moduleId, index, fieldId) {
      if(this.checkFieldChange) {
        if(typeof(fieldId) == "undefined" || fieldId == null)
          this.changedField = [];

        let moduleDeleted = false;
        for(let gk in this.groupDatas) {
          if(typeof(groupId) == "undefined" || groupId == null || gk == groupId) {
            for(let mk in this.groupDatas[gk]) {
              if(typeof(moduleId) == "undefined" || moduleId == null || mk == moduleId
                  || (Object.prototype.toString.call(moduleId) == "[object Array]" && moduleId.indexOf(mk) > -1)) {
                if(!moduleDeleted && _.differenceWith(this.oldGroupDatas[gk][mk], this.groupDatas[gk][mk], function (a, b){
                  return a.MODULE_NUM == b.MODULE_NUM;
                }).length > 0)
                  moduleDeleted = true; // 有组被删除

                // 检查值是否有修改
                for(let i = 0; i < this.groupDatas[gk][mk].length; i++) {
                  if(typeof(index) == "undefined" || index == null || i == index) {
                    let newModule = this.groupDatas[gk][mk][i];
                    if(newModule.MODULE_CONTROL == "0"){
                      continue;
                    }
                    let oldModule = null;
                    if (newModule.MODULE_ADD === "0" && newModule.MODULE_DELETE === "0")
                      oldModule = newModule.MODULE_SEQ ? _.find(this.oldGroupDatas[gk][mk], { "MODULE_SEQ": newModule.MODULE_SEQ }) : null;
                    else
                      oldModule = _.find(this.oldGroupDatas[gk][mk], {"MODULE_NUM": newModule.MODULE_NUM}) || null;

                    for(let fk in newModule["FIELDS"]) {
                      //隐藏字段不校验是否修改了 和 填写错误的字段不校验是否有修改
                      if (newModule["FIELDS"][fk]["FIELD_CONTROL"] == "1" || newModule["FIELDS"][fk].correct === false || newModule["FIELDS"][fk].correct === "false") {
                        continue;
                      }
                      if(typeof(fieldId) == "undefined" || fieldId == null || fk == fieldId) {
                        if(oldModule && fk in oldModule["FIELDS"]
                            && oldModule["FIELDS"][fk]["DEFAULT_VALUE"] == newModule["FIELDS"][fk]["DEFAULT_VALUE"]) {
                          let fIndex = mk + newModule["MODULE_SEQ"] + "|" + newModule["MODULE_NUM"] + fk;
                          let idx = this.changedField.indexOf(fIndex);
                          if(idx > -1) // 相同值无修改，从数组移除
                            this.changedField.splice(idx, 1);

                          newModule["FIELDS"][fk]["showchange"] = false;
                        } else if((oldModule && fk in oldModule["FIELDS"]) || (newModule["FIELDS"][fk]["DEFAULT_VALUE"] && newModule["FIELDS"][fk]["DEFAULT_VALUE"] != "false")) { // 如果有旧值，直接判断为修改，如果没旧值，新值不为空才判修改
                          let fIndex = mk + newModule["MODULE_SEQ"] + "|" + newModule["MODULE_NUM"] + fk;
                          let idx = this.changedField.indexOf(fIndex);
                          if(idx == -1)
                            this.changedField.push(fIndex); // 值不同有修改，添加进数组

                          newModule["FIELDS"][fk]["showchange"] = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if(moduleDeleted || this.changedField.length > 0) {
          this.isShowRestore = true;
        } else if(this.modifyType == 2) { // 控制是否显示还原,如果模型状态为待修改则不显示
          this.isShowRestore = false;
        } else {
          this.isShowRestore = false;
        }

        //新增需求：还原按钮为显示状态时，如果模块所有字段都不可编辑，隐藏还原按钮
        //如果传了fieldId就说明只检查字段有无改变，因为该需求只在页面初始化时执行
        if(this.isShowRestore && (typeof(fieldId) == "undefined" || fieldId == null)) {
          let hideBtn = true;
          for(let mId in this.moduleDatas) {
            this.moduleDatas[mId].map((module)=>{
              let fields = module.FIELDS;
              for(let fk in fields){
                if(fields[fk].FIELD_CONTROL != "2"){
                  //只要有一个字段不为无法编辑，则显示还原按钮
                  hideBtn = false;
                  break;
                }
              }
            });
          }

          if(hideBtn){
            //不显示还原按钮
            this.isShowRestore = false;
          }
        }
      } else {
        this.isShowRestore = false;
      }
      // this.$closest("bizFlow").isShowJumpButton();
    },
    /**
     * @method addModuleClick
     * @desc 点击添加模块方法 执行钩子函数
     * @param {Object} data 模块数据
     * @return {Boolean} true校验通过，false校验失败
     */
    addModuleClick (data){
      if(data != "") {
        let groupId = data.GROUP_ID;
        let moduleId = data.MODULE_ID;
        let index = data.INDEX;
        //如果有自定义的添加模块之前的校验逻辑 则跳转校验，否则默认校验通过
        if("addModule" in this.busiLogic) {
          return this.busiLogic["addModule"](this, moduleId , this.groupDatas[groupId][moduleId][index]["FIELDS"]);
        }else{
          return true;
        }
      }
    },
    /**
     * @method addModuleFinished
     * @desc 点击添加模块方法 执行钩子函数
     * @param {Object} data 模块数据
     * @return {Boolean} true校验通过，false校验失败
     */
    addModuleFinished (fieldData, moduleArr){
      this.$nextTick( () => {
        this.checkRequiredNull();
      });
      if(fieldData != "") {
        //如果有自定义的添加模块之前的校验逻辑 则跳转校验，否则默认校验通过
        if("addModuleFinished" in this.busiLogic) {
          return this.busiLogic["addModuleFinished"](this,fieldData, moduleArr);
        }else{
          return true;
        }
      }
    },
    /**
   * @method deletedModuleClick
   * @desc 点击删除模块方法 执行钩子函数
   * @param {Object} data 模块数据
   * @return {Boolean} true校验通过，false校验失败
   */
    deleteModuleClick (data){
      if(data != "") {
        let groupId = data.GROUP_ID;
        let moduleId = data.MODULE_ID;
        let index = data.INDEX;
        //如果有自定义的添加模块之前的校验逻辑 则跳转校验，否则默认校验通过
        if("deleteModule" in this.busiLogic) {
          return this.busiLogic["deleteModule"](this, this.groupDatas[groupId][moduleId][index], index);
        }else{
          return true;
        }
      }
    },
    /**
    * @method deleteModuleFinished
    * @desc 点击删除模块方法 执行钩子函数
    * @param {Object} data 模块数据
    * @return {Boolean} true校验通过，false校验失败
    */
    deleteModuleFinished (data) {
      this.$nextTick( () => {
        this.checkRequiredNull();
      });
      if (data && data.length) {
        let groupId = data[0].GROUP_ID;
        let moduleId = data[0].MODULE_ID;
        let index = data[0].INDEX;
        let deleteObj = data[0];
        //如果有自定义的添加模块之前的校验逻辑 则跳转校验，否则默认校验通过
        if ("deleteModuleFinished" in this.busiLogic) {
          return this.busiLogic["deleteModuleFinished"](this, deleteObj, this.groupDatas[groupId][moduleId]);
        } else {
          return true;
        }
      }
    },
    queryModule (data) {
      //如果有自定义的添加模块之前的校验逻辑 则跳转校验，否则默认校验通过_
      if ("queryModule" in this.busiLogic) {
        return this.busiLogic["queryModule"](this, data);
      } else {
        return true;
      }
    },
    // 重新加载页面
    /**
     * @method refreshPage
     * @desc 刷新页面
     */
    refreshPage: function (){
      this.initPage();
      this.messageTypeShow = false;
    },
    getOcrInfo:function (cardInfo){
      this.showOcrCard = false;
      if(cardInfo && !_.isEmpty(cardInfo)){
        let groupId = this.groupId;
        let moduleId = this.showOcrModuleId;
        if("readModule" in this.busiLogic) {
          this.busiLogic["readModuleCardInfoAction"](this, moduleId , this.cardFieldData,cardInfo);
        }
      }
    },
    ocrBackAction:function (val){
      this.showOcrCard = val;
    },
    nextCsdcInfo (csdcInfo){
      this.showCsdcInfoPage = false;
      if(csdcInfo && !_.isEmpty(csdcInfo)){
        if("ZDCustomizeModule" in this.busiLogic) {
          this.busiLogic["ZDCustomizeModuleAction"](this, csdcInfo);
        }
      }
    },
    cancelCsdcInfo () {
      this.showCsdcInfoPage = false;
    },

    /**
     * @method fieldOnChangeDetail
     * @desc 页面字段监控 如果值改变则触发 包含空值
     */
    checkRequiredNull: function () {
      try {
        let groupId = this.groupId;
        let moduleId = this.moduleId;
        for( let gk in this.groupDatas) {
          if (gk && gk == groupId) {
            for (let mk in this.groupDatas[gk]) {
              if (mk && (mk == moduleId || moduleId.indexOf(mk) > -1)) {
                let moduleData = this.groupDatas[gk][mk];
                _.each(moduleData, (moduleItem, index) => {
                  if (moduleItem.MODULE_CONTROL != "1") {
                    return;
                  }
                  let moduleItem_seq = moduleItem.MODULE_SEQ || "";
                  _.each(moduleItem.FIELDS, fieldItem => {
                    let fieldId = fieldItem.FIELD_ID || "";
                    let moduleInfo = this.groupDatas[gk][mk][index];
                    let fieldData = this.groupDatas[gk][mk][index].FIELDS;
                    let field = this.groupDatas[gk][mk][index].FIELDS[fieldId];
                    if (fieldId) {
                      let component = field.component;
                      let componentFnArr = {
                        normalinput: "textinput",
                        checker: "checkbox",
                        radio: "checkbox",
                        date: "datebox",
                        selector: "combobox",
                        multiSelector: "combobox",
                        telephone: "telinput",
                      };
                      let componentFn = componentFnArr[component] || "";
                      this.$refs[mk + moduleItem_seq] && this.$refs[mk + moduleItem_seq][0].$refs[fieldId][0].$watch("dataChange", (newVal, oldVal)=> {
                        this.busiLogic["fieldDataChange"] && this.busiLogic["fieldDataChange"](this, field, fieldData, moduleInfo);
                      });
                    }
                  });
                });
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    //获取dom距离顶部的距离
    getElementToPageTop (el) {
      let offsetTop = 0;
      if (el.parentElement) {
        offsetTop = el.parentElement.offsetTop;
      }
      if (offsetTop > 0) {
        return offsetTop;
      }
      const getElOffsetTop = (el) => {
        if (!el.offsetParent) {
          return 0;
        }
        // console.error(el.offsetParent.className)
        if (el.offsetParent.className.indexOf("routeBox") > -1) {
          return el.offsetTop;
        }
        return getElOffsetTop.call(this, el.offsetParent);
      };
      return getElOffsetTop(el.offsetParent);
    },
    showLoading (text) {
      if (!!text) {
        this.myLoading({

          loadingText: text || "正在核对您的业务状态&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    },
    moduleCustomizeSameChange (val) {
      if (val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let isChecked = val.MODULE_CHECKED;
        let el = val.MODULE_EL;
        let moduleArr = this.groupDatas[groupId][moduleId];
        let flag = false;
        let currentModule = {};
        _.each(moduleArr, (item) => {
          if (item.MODULE_SEQ == moduleSeq &&
            "moduleCustomizeSameChange" in this.busiLogic) {
            flag = true;
            currentModule = item;
            currentModule.withoutChecked = val.withoutChecked;
          }
        });
        if (!flag) {
          return false;
        }
        return this.busiLogic["moduleCustomizeSameChange"](
          this,
          moduleId,
          currentModule,
          isChecked,
          moduleArr,
          el
        );
      }
    },
    moduleCustomizeWithoutChange (val) {
      if (val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let isChecked = val.MODULE_CHECKED;
        let el = val.MODULE_EL;
        let moduleArr = this.groupDatas[groupId][moduleId];
        let flag = false;
        let currentModule = {};
        _.each(moduleArr, (item) => {
          if (item.MODULE_SEQ == moduleSeq &&
            "moduleCustomizeWithoutChange" in this.busiLogic) {
            flag = true;
            currentModule = item;
          }
        });
        if (!flag) {
          return false;
        }
        return this.busiLogic["moduleCustomizeWithoutChange"](
          this,
          moduleId,
          currentModule,
          isChecked,
          moduleArr,
          el
        );
      }
    }
  },
  watch: {
    clickLeftStep (val){
      let that = this;
      if (!val) return;
      that.$emit("change-toplink-name", "");
      // 离开前校验当前页面字段
      if (that.runFieldValidate() == false) {
        return;
      }
      let data = that.parseGroupData(),
        errorFields = data[0],
        /**
           * lbj 不再从 parseGroupData 中取数据保存
           */
        params = that.historyData;
      if(errorFields.length > 0) {
        // 如果有字段校验不通过，自动滚动到该字段
        if (errorFields[0] instanceof Array && document.querySelector(".el-form-item_error")) {
          let padding_top = 450; // 预留顶部空间
          // document.querySelector('#bizEntry-main').scrollTop = document.querySelector(`#${errorFields[0][3]}`).offsetTop + document.querySelector(`#${errorFields[0][2]}`).offsetTop - padding_top;
          document.querySelector("#bizEntry-main").scrollTop = that.getElementToPageTop(document.querySelector(".el-form-item_error")) - padding_top; // 改为定位首个错误提示父元素
        }else if (!(errorFields[0] instanceof Array) && document.querySelector(".el-form-item__error")) {
          let padding_top = 450; // 预留顶部空间
          document.querySelector("#bizEntry-main").scrollTop = that.getElementToPageTop(document.querySelector(".el-form-item__error")) - padding_top; // 改为定位首个错误提示父元素
        }
        if(window.isOnlyMaskTool&&window.MaskTool&&["V9998"].includes(that.busiCode)){
          window.MaskTool.coverGuide(document.getElementsByName(errorFields[0][3]+"-"+errorFields[0][4]+"-"+errorFields[0][2])[0],3000,"1");
        }else{
          vm.$alert(_.isString(errorFields[0]) ? errorFields[0] : "'" + errorFields[0][1] + "'等字段输入错误或必填\n请更改后重试");
        }
        return false;
      }
      return Promise.all([
        that.busiLogic.validate && _.isFunction(that.busiLogic.validate) ? that.busiLogic.validate(that) : true
      ]).then(function (res) {
        if(res[0] === false) {
          return;
        }

        if(!that.isCommit) { // 不提交需缓存当前业务数据
          // that.$storage.setSession(that.$definecfg.BUSI_INFO, params);
          //更新historydata的值
          that.historyData = Object.assign(that.historyData, params);
          that.$emit("clickLeftStepBack", val);
        } else {

          that.showLoading("正在核对您提交的业务数据...");
          return that.save(that, params).then(function (response) {
            that.$emit("clickLeftStepBack", val);
          }).catch(function (err) {
            if(err !== "preventNextStep") {   //阻止跳转下一页
              alert(err.toString() + "，保存失败");
            }
          }).finally(function (){
            that.showLoading();
          }) ;
        }
      });
    },
    /**
     * @watch pageNum
     * @param {Number} val
     * @desc 监控pageNum，发生变化时重新初始化页面
     */
    pageNum (val) {
      this.initPage();
    },
    moduleButtonClick (val) {
      if(val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let moduleArr = this.groupDatas[groupId][moduleId];
        _.each(moduleArr, (item, index) => {
          if (item.MODULE_SEQ == moduleSeq && "readModule" in this.busiLogic) {
            this.busiLogic["readModule"](this, moduleId , this.groupDatas[groupId][moduleId][index]["FIELDS"], this.groupDatas[groupId][moduleId][index]);
          }
        });
      }
    },
    moduleCustomizeButtonClick (val) {
      if(val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let moduleArr = this.groupDatas[groupId][moduleId];
        _.each(moduleArr, (item, index) => {
          if (item.MODULE_SEQ == moduleSeq && "customizeModule" in this.busiLogic) {
            this.busiLogic["customizeModule"](this, moduleId , this.groupDatas[groupId][moduleId][index]["FIELDS"], this.groupDatas[groupId][moduleId][index]);
          }
        });
      }
    },
    moduleZDCustomizeButtonClick: function (val) {
      if(val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let moduleArr = this.groupDatas[groupId][moduleId];
        _.each(moduleArr, (item, index) => {
          if (item.MODULE_SEQ == moduleSeq && "ZDCustomizeModule" in this.busiLogic) {
            this.busiLogic["ZDCustomizeModule"](this, moduleId , this.groupDatas[groupId][moduleId][index]["FIELDS"], this.groupDatas[groupId][moduleId][index]);
          }
        });
      }
    },
    moduleImportButtonClick: function (val) {
      if (val != "") {
        this.busiLogic["importModule"](this, val);
      }
    },
    moduleDownloadButtonClick: function (val) {
      if (val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = val.MODULE_SEQ;
        let moduleArr = this.groupDatas[groupId][moduleId];
        _.each(moduleArr, (item, index) => {
          if (item.MODULE_SEQ == moduleSeq && "downloadModule" in this.busiLogic) {
            this.busiLogic["downloadModule"](this, moduleId , this.groupDatas[groupId][moduleId][index]["FIELDS"], this.groupDatas[groupId][moduleId][index]);
          }
        });
      }
    },
    componentButtonClick: function (val) {
      if(val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let fieldId = val.FIELD_ID;
        let i = parseInt(val.index);
        let field = this.groupDatas[groupId][moduleId][i]["FIELDS"][fieldId];
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, "");
        let cols = field.FIELD_FUNCTION.split("|");
        for(let i = 0; i < cols.length; i++) {
          let cType = cols[i] + "__CLICK";
          if(cType in this.busiLogic) {
            this.busiLogic[cType](this, field, this.groupDatas[groupId][moduleId][val.index]["FIELDS"], this.groupDatas[groupId][moduleId][i]);
          }
        }
      }
    },
    moduleBenifiCustomizeButtonClick: function (val) {
      if (val != "") {
        var that = this;
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let moduleSeq = parseInt(val.MODULE_SEQ);
        let moduleArr = this.groupDatas[groupId][moduleId];
        let fieldId = val.FIELD_ID;

        _.each(moduleArr, (item, index) => {
          if (moduleSeq === index) {
            let field = item["FIELDS"][fieldId];
            this.$store.commit(this.$types.UPDATE_MODULE_BENIFICUSTOMIZE_BUTTON_CLICK, "");
            let cols = field.FIELD_FUNCTION.split("|");
            for (let i = 0; i < cols.length; i++) {
              let cType = val.type && val.type == "regionSelect" ? (cols[i] + "__SELECT") : (cols[i] + "__CLICK");
              if (cType in that.busiLogic) {
                that.busiLogic[cType](that, field, item["FIELDS"], item, index, "0");
              }
            }
          }
        });
      }
    },
    componentButtonTwoClick: function (val) {
      if(val != "") {
        let groupId = val.GROUP_ID;
        let moduleId = val.MODULE_ID;
        let fieldId = val.FIELD_ID;
        let i = parseInt(val.index);
        let field = this.groupDatas[groupId][moduleId][i]["FIELDS"][fieldId];
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_TWO_CLICK, "");
        let cols = field.FIELD_FUNCTION.split("|");
        for(let i = 0; i < cols.length; i++) {
          let cType = cols[i] + "__CLICK_TWO";
          if(cType in this.busiLogic) {
            this.busiLogic[cType](this, field, this.groupDatas[groupId][moduleId][val.index]["FIELDS"], this.groupDatas[groupId][moduleId][i]);
          }
        }
      }
    },

    fieldChange: function (val) {
      if(!this.$router.getCurrentRoute().ignoreFieldCheck && val && val.module_id in this.moduleDatas) {
        this.checkChangedValues(this.groupId, val.module_id, val.index, val.field_id);

        if(val.field_id) {
          let field = this.moduleDatas[val.module_id][val.index]["FIELDS"][val.field_id];
          let fieldData = this.moduleDatas[val.module_id][val.index].FIELDS;
          // let field = this.fieldData[val.field_id];
          if(field.FIELD_FUNCTION) { // 字段值变化，触发相应的自定义规则
            let cols = field.FIELD_FUNCTION.split("|");
            for(let i = 0; i < cols.length; i++) {
              let cType = cols[i];
              if(cType in this.busiLogic) {
                this.busiLogic[cType](this, field, fieldData, this.moduleDatas[val.module_id][val.index], val.index, "0");
              }
            }
          }
        }
      }
    },
    fieldValueChange: function (val) {
      if(!this.$router.getCurrentRoute().ignoreFieldCheck && val && val.module_id in this.moduleDatas) {
        this.checkChangedValues(this.groupId, val.module_id, val.index, val.field_id);
        if(val.field_id) {
          let field = this.moduleDatas[val.module_id][val.index]["FIELDS"][val.field_id];
          let fieldData = this.moduleDatas[val.module_id][val.index].FIELDS;
          if(field.FIELD_FUNCTION_CHANGE) { // 字段值变化，触发相应的自定义规则
            let cols = field.FIELD_FUNCTION_CHANGE.split("|");
            for(let i = 0; i < cols.length; i++) {
              let cType = cols[i];
              if(cType in this.busiLogic) {
                this.busiLogic[cType](this, field, fieldData, this.moduleDatas[val.module_id][val.index]);
              }
            }
          }
        }
      }
    },

    closeFlowtipClick:function (val) {
      let that = this;
      return Promise.all([
        that.busiLogic.closeFlowtip && _.isFunction(that.busiLogic.closeFlowtip) ? that.busiLogic.closeFlowtip(this, val) : true
      ]).then(function (res) {

      });
    },
    "disabledArray": {
      handler (newVal, oldVal) {
        this.$nextTick(()=>{
          //清除旧的提示
          this.removeFlowTip("notUpdateAppt");
          this.removeFlowTip("noEditAuth");
          this.removeFlowTip("foribinMobileLogin");
          newVal.forEach(v=>{
            this.pushFlowTip(v);
          });
        });
      },
      immediate: true
    },
  }
};
</script>

<style lang="less">
.bizEntry-page {
  .bizEntry-main {
    margin-top: 0;
    margin-right: 5px;
    flex-basis: 0%;
    padding: 8PX;
    overflow: auto;
    background: #fff;
    .el-form-item {
      margin-bottom: 15px;
      .el-form-item__label{
        width: 230px;
        padding: 0;
      }
      .el-form-item__content {
        line-height:1;
        .el-input__inner {
          &:focus {
            // border: none !important;//删除组件，下横线加粗
            // border-bottom: 1px solid #000 !important;//删除组件，下横线加粗
          }
        }
      }
    }
  }
  .bizEntry-footer {
    // position: relative;
    // height: 77.5px!important;
    // height: 40px !important;
    // padding-top: 17.5px;
    // padding-top: 5px;
    box-sizing: border-box;
    //统一放到index.vue
    .el-col {
    //   .kui-button {
    //     .el-button {
    //       font-weight: 500;
    //       height: 40px;
    //       &.el-button--default {
    //         min-width: 125px;
    //         height: 40px;
    //         color: #e53232;
    //         border: 1px solid #e53232;
    //       }
    //       &.el-button--primary {
    //         min-width: 135px;
    //         color: #fff;
    //         background-image:linear-gradient(90deg,#e52323 0%,#e83030 100%);
    //       }
    //     }
    //   }

    //   .entry-prev-button{
    //     .kui-button-each{
    //       background-color:#F7F8FA !important;
    //     }
    //   }
    // }
    // //添加关于上一步，下一步的字体设置
    // .el-col-4 {
    //   width: auto !important;
    //   // margin: 15px  18px 0 18px;
    //   .el-button {
    //   font-size: 20px !important;
    //     padding: 5px 10px !important; // 调整按钮的内边距
    //   }
    // }

    // .el-col-5 {
    //   width: auto !important;
    //   margin: 15px  18px 0 18px;
    }
    .pageIndex {
      width: 0 !important;
      .pageIndexText{
          padding-left: 0 !important;
          padding-right: 0 !important;
          text-align: right;
          width: 200px;
          height: 60px;
          line-height: 60px;
          font-size: 21px;
          display: block;
          align-items: center;
          font-weight: 500;
          position:absolute;
          padding-right: 30px;
          right: 40px;
          bottom: 0;
          top: 0;
          letter-spacing:7px;
          &.page-help {
              width:40px;
              right: -5px;
              font-size:26px;
              color: #c52525;
          }
        }
    }

  }
  .kui-dialog {
    &.fund-dialog {
      .el-dialog__header {
        padding: 15px 0;
      }
      .el-dialog__body {
        text-align:center;
        .fund-qr-code {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 150px;
        }
        .fund-qr-text {
          display: block;
          font-size: 16px;;
        }
      }
    }

  }
}
// @media screen and (min-aspect-ratio:4/3){
//   .bizEntry-page {
//     cursor: pointer;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/pages/bizEntry/bizEntry.vue